import React from 'react'
import PropTypes from 'prop-types'
import { Trans } from 'react-i18next'
import { getNotificationContent } from '../content'
import { relativeTimeParts } from '../relativeTime'

const LowUpdateFrequencyDetail = ({ notification, onReview, t }) => {
  const { title } = getNotificationContent(notification, t)
  const time = relativeTimeParts(notification.createdAt)

  return (
    <React.Fragment>
      <div className="NotificationDetail-Category NotificationDetail-Category--warning">
        {t('notificationCenter.types.lowUpdateFrequency.category')}
      </div>
      <div className="NotificationDetail-Summary">
        <p className="NotificationDetail-Summary-Title">{title}</p>
        <p className="NotificationDetail-Summary-Time">{t(time.key, time.options)}</p>
      </div>
      <p className="NotificationDetail-Description">
        <Trans
          i18nKey="notificationCenter.types.lowUpdateFrequency.bodyRich"
          components={{ bold: <strong/> }}
        />
      </p>
      <button type="button" className="NotificationDetail-ReviewButton" onClick={onReview}>
        {t('notificationCenter.types.lowUpdateFrequency.reviewAction')}
      </button>
    </React.Fragment>
  )
}

LowUpdateFrequencyDetail.propTypes = {
  notification: PropTypes.object.isRequired,
  onReview: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
}

export default LowUpdateFrequencyDetail
